export class FbNotes{
  public imgSrc: string;
  public notes: string
  public isEditable: boolean;

  constructor(imgSrc: string, notes: string, isEditable: boolean) {
    this.imgSrc = imgSrc;
    this.notes = notes;
    this.isEditable = isEditable;
  }

  hasImage(): boolean {
    return this.imgSrc != "";
  }
}



// WEBPACK FOOTER //
// ./src/model/FbNotes.ts